import Icon from "./icon-base";
import { store as storeMarker } from "@/data/map-markers";

export default {
	name: "KTrucksMapStoreIcon",

	mixins: [ Icon ],

	data: () => ( {
		marker: storeMarker
	} )
};
